import React from 'react';
import "./accounting.css";
import { accountMenu } from '../../constant';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { handleMenu } from '../../store/actions/accounts.action';
import { ledgerBackDetails } from '../../store/actions/employee';

const ModuleMenu = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const { showAccountingMenu } = useSelector((state) => state.accountingReducer);
    let navigate = useNavigate();
    const handleNavigate = (path) => {
        navigate(path);
        handleMenuDisplay();
        dispatch(ledgerBackDetails({}));
    };

    const handleMenuDisplay = () => {
        dispatch(handleMenu(!showAccountingMenu));
    }

    return (
        <div className='accountingMenuWrapper col-lg-2 col-sm-12'>
            <div className={`${showAccountingMenu && 'pl-2 mt-1'} menuBar__icon`}>
                <i className="fa fa-bars mr-2" aria-hidden="true" onClick={handleMenuDisplay}></i> Accounting
            </div>
            {showAccountingMenu && (
                <div className="accountingMenu pl-0 mt-1">
                    <div className='headingMenu'>
                        {accountMenu.map((item) => (
                            <button className={`sortBtn sortBtnMenu menuItem ${location.pathname.startsWith(item.path) ? "active" : ""}`}
                                key={item.id} onClick={() => handleNavigate(item.path)}>
                                <span className={`${item.isActive ? 'active' : ''}`}>
                                    <i className={item.icon} aria-hidden="true"></i> {item.name}
                                </span>
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}
export default ModuleMenu;